import { RightEnum } from "@finway-group/shared/lib/models"
import { Col, Row, Tag } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useUserCreditors } from "~Shared/hooks/vendor.hooks"
import { useEmployees } from "~Shared/queries/employee.queries"
import { useVendor } from "~Shared/queries/vendors/vendor.queries"
import { AuthzService } from "~Shared/services"
import { createFilterTagsArray } from "~Shared/utils/filter.utils"

interface FilterSectionProps<FilterType extends Record<string, unknown>> {
    filters: FilterType
    onRemove: (filter?: keyof FilterType) => void
}

export const FilterSection = <FilterType extends Record<string, any>>({ filters, onRemove }: FilterSectionProps<FilterType>) => {
    const { t } = useTranslation()
    const { data: employees = [] } = useEmployees({ excludeDeleted: true })
    const { data: filterVendor } = useVendor(filters?.vendor?.toString())
    const userCreditors = useUserCreditors(AuthzService.isRightGrantedForLoggedInUser(RightEnum.EMPLOYEE__ALL__READ))
    const filterTags = createFilterTagsArray(filters, undefined, { employees, filterVendor, userCreditors })

    return (
        <Row className="mb-14">
            <Col span={24}>
                {filterTags.map(({ name, label, value }) => (
                    <Tag key={name} className="ant-tag-filter p-4 mr-10 mt-4 mb-4" closable onClose={() => onRemove(name)}>
                        {label ?? name}: {value}
                    </Tag>
                ))}

                {filterTags.length > 1 && (
                    <Tag className="ant-tag-filter p-4 mr-10 mt-4 mb-4" onClick={() => onRemove()} style={{ cursor: "pointer" }} key={"clearTag"}>
                        <span className="font-normal">{t("action:clear_all")}</span>
                    </Tag>
                )}
            </Col>
        </Row>
    )
}
